// import getApolloClient from './apolloClient'
import gql from 'graphql-tag'
// import { gql, useMutation } from '@apollo/client'
// import { formDataAppendFile } from 'apollo-upload-client'
import Vue from 'vue'
import axios from 'axios'

export default class FeedbackApi {
  async getHeaders(type) {
    const token = await Vue.prototype.$auth.getUserToken()
    const headers = {
      'Content-Type': type || 'multipart/form-data',
      'Authorization': `Bearer ${token ? token : ''}`,
      'Auth-Provider': 'SmartId',
      'OrganizationItId': sessionStorage.getItem('OrganizationItId'),
      'Access-Control-Allow-Headers': '*',
      'Access-Control-Allow-Origin': '*',
      'culture': sessionStorage.language,
      'accept-language': sessionStorage.language,
      'href': window.location.href,
    }
    if (crypto?.randomUUID)  {
      headers.correlationId = crypto.randomUUID()
    }
    return headers
  }

  getGqlString(doc) {
    return doc.loc && doc.loc.source.body
  }

  async sendFeedback(path, type, task, files) {
    let sendFeedback = await import('./graphql/feedback/addFeedback.graphql')
    let formdata = new FormData()

    const query = {
      query: this.getGqlString(gql`${sendFeedback}`),
      variables: {
        path: path,
        type: type,
        task: task,
        files: files.map(() => null),
      },
      operationName: null
    }
    Vue.prototype.$log(JSON.stringify(query))
    formdata.append('operations', JSON.stringify(query))

    let mapdata = {}
    files.forEach((file, i) => {
      formdata.append(`${i}`, file)
      mapdata[`${i}`] = [`variables.files.${i}`]
      formdata.append(`${i}`, file, file.name)
    })
    Vue.prototype.$log(JSON.stringify(mapdata))
    formdata.append('map', JSON.stringify(mapdata))
    Vue.prototype.$log(JSON.stringify(formdata))

    const uri = window.config.GrapgQlUrl + '/feedback'
    return axios.post(uri, formdata,
      {
        headers: await this.getHeaders(),
        onUploadProgress: this.listener
      })
  }

  axiosListener = function (progressEvent) {
    let loadingPercentage = Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total )
    Vue.prototype.$log(loadingPercentage)
  }
}
